import React from 'react'

import { SxProps } from '@mui/material'

import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'

interface Props {
  sx?: SxProps
}

const Locked = (props: Props) => {
  const { sx } = props
  const { t } = useTranslation()

  return (
    <Box sx={sx}>
      <EmptyPlaceholder
        actions={
          <>
            <Button to="/metrics" variant="outlined">
              {t('global', 'back')} {t('global', 'to', true)}{' '}
              {t('metrics', 'all_metrics', true)}
            </Button>
          </>
        }
        background={true}
        body={t('metrics', 'locked_body')}
        height={512}
        size="medium"
        title={t('global', 'locked_title')}
      />
    </Box>
  )
}

export default Locked
